import { FC } from 'react';
import { WbCard } from '@agilelab/plugin-wb-platform';
import { Dialog } from '@material-ui/core';
import { useReleaseDetailPageContext } from '../context/useReleaseDetailPageContext';
import { AdvancedProvisioning } from './AdvancedProvisioning';
import { BasicProvisioning } from './BasicProvisioning';
import { useDeploymentPreviewContext } from './context/useDeploymentPreviewContext';

export const DeploymentPreviewModal: FC = () => {
  const { isAdvanced, setIsAdvanced } = useDeploymentPreviewContext();
  const { isDeploymentPreviewOpen, setIsDeploymentPreviewOpen } =
    useReleaseDetailPageContext();

  return (
    <Dialog
      open={isDeploymentPreviewOpen}
      onClose={() => {
        setIsDeploymentPreviewOpen(false);
        setIsAdvanced(false);
      }}
      PaperProps={{ 'aria-label': 'deployment-preview-dialog' }}
      maxWidth="xl"
      fullWidth
    >
      <WbCard
        title="Summary Preview"
        cardStyle={{
          boxShadow: 'none',
          display: 'flex',
          flexDirection: 'column',
          height: '70vh',
        }}
      >
        {isAdvanced ? <AdvancedProvisioning /> : <BasicProvisioning />}
      </WbCard>
    </Dialog>
  );
};
